/* tslint:disable */
/* eslint-disable */
/**
 * Auth Service API
 * Auth Service API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BrandAccessDtoFromJSON, BrandAccessDtoToJSON, } from './BrandAccessDto.js';
/**
 * Check if a given object implements the UpdateUserAccessDto interface.
 */
export function instanceOfUpdateUserAccessDto(value) {
    if (!('brandAccess' in value) || value['brandAccess'] === undefined)
        return false;
    return true;
}
export function UpdateUserAccessDtoFromJSON(json) {
    return UpdateUserAccessDtoFromJSONTyped(json, false);
}
export function UpdateUserAccessDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'brandAccess': BrandAccessDtoFromJSON(json['brandAccess']),
    };
}
export function UpdateUserAccessDtoToJSON(json) {
    return UpdateUserAccessDtoToJSONTyped(json, false);
}
export function UpdateUserAccessDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'brandAccess': BrandAccessDtoToJSON(value['brandAccess']),
    };
}
//# sourceMappingURL=UpdateUserAccessDto.js.map